<div class="d-flex flex-column gap-2">
  <div
    class="p-0 text-decoration-none d-flex gap-2 align-items-center justify-content-between text-start cursor-pointer hover-effect my-2"
    (click)="toggleCollapsed()"
    [attr.aria-expanded]="!isCollapsed"
  >
    <span>{{ description }}</span>
    <ng-content select="[header-actions]"></ng-content>
    <span class="rb-ic rb-ic-down fs-lg" [class.rotate-180]="isCollapsed"></span>
  </div>
  <div
    class="d-flex flex-wrap column-gap-4 mb-2 justify-content-start"
    [class.d-none]="isCollapsed"
  >
    <div style="display: flex; flex-direction: row; gap: 12px">
      <ng-content></ng-content>
    </div>
  </div>
</div>
